import getBasePath from '../functions/api-resource';
import genericActions from './generic-resource';

const basePath = getBasePath('api', 'sell-in');

const sellInActions = {
  ...genericActions(basePath),
  listarConsolidado: { method: 'GET', url: `${basePath}/consolidado?tamanhoPagina={size}&numeroPagina={page}` },
  listarDetalhado: { method: 'GET', url: `${basePath}/obter/detalhado?nota={nota}&competencia={competencia}&cliente={idcliente}&filtro={filter}` },
  periodos: { method: 'GET', url: `${basePath}/periodos` },
};

export default (resource) => resource(`${basePath}`, {}, sellInActions);
